/**
 * 共通コントロール（TextBox)
 * isdTextBox
 */
import React, { useImperativeHandle, useRef, useState } from "react";
import { useEffect } from "react";
import ReactDOM from 'react-dom';
import { getSearchFormMaxLength, getSearchName, setValueByKey, getValueByKey, setPassThroughValue, setGyData } from '../../util/directive-utils'
import { isNotUndefined, isUndefined, isEmpty, isNotEmpty, calcInputSize } from '../../util/util'
import { searchFormMap } from './searchformmap'
import $, { type } from 'jquery';
import DialogBase from "./DialogBase";
import { observer } from "mobx-react";
import errMsgService from "../../services/common/errMsgService";
import constMap from "../../const/const";
import stateStore from "../../store/stateStore";

// IME入力フラグ　IME入力処理の状態を格納するフラグメント
let isIme = false;

// フォーカスフラグ　フォーカス状態を格納するフラグメント
let isFocus = false;

// pasteフラグ　paste処理の状態を格納するフラグメント
let isPaste = false;

// props.ctrlproptypeを格納するための変数を宣言
let valueOfCtrlPropType;

// searchform
let config = {
    isdMaxlength: null
    , size: '0'
    , replaced: ''
};
let footerOptionsConfig = {
    detailBtn: null,
    clearBtn: null,
    commitBtn: null,
    endBtnFunc: null,
}
let isBlur = false;
let execFinlyFuncFlg = false;

const IsdTextBox = observer(React.forwardRef((props, ref) => {
    // props.valueの値をコンポーネント内の初期stateとして与える
    const [value, setValue] = useState('');

    // formatメソッドで画面にprops.valueを表示する際、表示形式を扱うstate
    const [displayType, setDisplayType] = useState(props.ctrlproptype ? props.ctrlproptype : "");

    // エラー状態を判別するstate
    const [isError, setIsError] = useState(false);
    // searchform
    const [multilModel, setMultilModel] = useState(false);
    const [inputConfig, setInputConfig] = useState(config);
    const [footerOptions, setFooterOptions] = useState(null);
    const [isModalHiden, setIsModalHiden] = useState(true);
    const textInput = useRef(null);
    let element = textInput ? $(textInput.current) : null;
    //TODO
    let isErrMsgDisp = false;
    const [beforeFocus, setBeforeFocus] = useState('');

    // 初レンダリング時、初期値のチェックとディスプレイタイプの設定を行う
    useEffect(() => {
        if (!!props.value && isEmpty(value)) {
            doCheck({ target: { value: props.value } });
        }
        // ディスプレイタイプにctrlproptypeを適用
        if (!isFocus && !isEmpty(props.ctrlproptype) && typeof props.ctrlproptype === 'string') {
            if (displayType != props.ctrlproptype) {
                setDisplayType(props.ctrlproptype);
            }
        }
        if (props.dataGrid) {
            $(textInput.current).on('blur', (event) => {
                onBlur(event);
            });
        }
    }, [])

    useEffect(() => {
        setValue(props.value);
        if (isUndefined(props.searchform)) return;
        if (isEmpty(props.value) && isNotUndefined(props.searchform)) {
            // 前回入力値を初期化する
            element.data("before-input", "");
        }
    }, [props.value]);

    useEffect(() => {
        if (isUndefined(props.searchform)) return;
        // 最大入力可能桁数の設定（データアクセスのある業務系部品に対してデフォルト値を設定する）
        let maxlength = getSearchFormMaxLength(props.searchform);
        // 銀行・支店は同じsearchform名であるが桁数は違うため調整する
        if (props.searchform === "bank-branch" && isNotUndefined(props.branch)) {
            maxlength -= 1;
        }
        config.isdMaxlength = props.isdMaxlength ? props.isdMaxlength : maxlength;
        config.size = (config.isdMaxlength == 1) ? 1 : config.isdMaxlength - 1;
        setFooterOptions(props.footerOptions ? props.footerOptions : footerOptionsConfig);
        // ボタンクリックから照会画面を開くときに、テキストボックスのattributeを渡すため保持する
        if (isNotEmpty(props.name)) {
            element.data("props", props);
        }
        // 内部保持データ初期化
        setGyData(stateStore, props, "");
        // TODO
        isErrMsgDisp = false;
        if (!isEmpty(props.searchform) && isUndefined(props.replaced)) {
            // F2参照画面を表示しない場合、ボタンを付与しない
            if (isUndefined(props.isPrimaryKey)) {
                setMultilModel(isNotUndefined(props.multiModal) ? true : false);
            }
        }
    });

    const shokaiShowup = (event) => {
        // モーダルによる選択画面を表示する
        const currentTarget = $(event.currentTarget);
        const modalbox = document.querySelector('.modal-dialog');
        if (event.key === "F2" || (event.key === "F3" && multilModel) || event.type === "click") {

            // モーダル種別
            const modalName = (event.key === "F3" || isNotUndefined(currentTarget.attr("multi-modal-btn"))) ? "multi-modal" : "modal";

            if (!isModalHiden && modalbox.style.display === 'block') return;
            // F2キーもしくはボタンクリック時は、照会画面を表示するためメッセージを表示しない
            // TODO
            isErrMsgDisp = true;
            setBeforeFocus('');

            // is-primary-keyが指定された場合、参照画面を発生させない
            if (isNotUndefined(props.isPrimaryKey)) return;

            // モーダル情報取得
            let modalOptions = searchFormMap[props.searchform][modalName];
            // モーダル情報が取得できない場合処理を終了する
            if (isEmpty(modalOptions)) return;
            // 呼出元画面のスコープをパラメータに設定
            modalOptions.parentProps = props;
            modalOptions.parentScope = stateStore;
            modalOptions.footerOptions = footerOptions;
            modalOptions.draggable = true;
            modalOptions.backdrop = false;

            // 照会画面に引き継ぐ値を設定する
            setPassThroughValue(stateStore.state, element, props);

            // 共通設定
            const rootElement = document.getElementById('root');
            const divElement = document.createElement('div');
            divElement.classList.add('dialog-base-contailer');
            divElement.classList.add('back-drop');
            const className = `dialog-search-form-${props.searchform}`;
            const searchformDialog = document.querySelector(`.${className}`);
            if (searchformDialog) return;
            rootElement.appendChild(divElement);
            ReactDOM.render(<DialogBase className={className} options={modalOptions} resultFunc={modalInstanceResult}></DialogBase>, divElement);
        }
    }

    /**
     * チェック処理及びDB検索実行（画面から呼び出し時、コールバック関数・パラメータ、内部変数を設定できる、※finally処理は、searchform実処理が呼ばれないときのみ実施する）
     * 
     * @param {any} callbackFunc 
     * @param {any} callbackParam 
     * @param {any} internalVar 
     * @param {any} errCallbackFunc 
     * @param {any} errCallbackParam 
     * @param {any} evt 
     * @param {any} finlyCallbackFunc 
     * @param {any} finlyCallbackParam 
     * @returns 
     */
    const exec = (callbackFunc, callbackParam, internalVar, errCallbackFunc, errCallbackParam, evt, finlyCallbackFunc, finlyCallbackParam) => {

        try {
            execFinlyFuncFlg = true;
            // TODO
            const errMsgService = null;
            const authService = null;
            // nodataaccessが指定された場合、DBアクセスしない
            if (isNotUndefined(props.nodataaccess)) {
                // コールバック関数がある場合、実施する
                if (isNotEmpty(callbackFunc)) callbackFunc(callbackParam);
                return;
            }

            // isNodataaccessがtrueの場合、DBアクセスしない
            if (isNotUndefined(props.isNodataaccess) && getValueByKey(props.isNodataaccess, stateStore.state)) return;

            // 入力データが空はDB検索しない
            if (isEmpty(value)) {
                //TODO errMsgService
                // if (isUndefined(props.required)) errMsgService.delMsgLabel(props);

                // 「is-empty-execute-callback」属性があるとき、空の入力値でもコールバックを実行する
                if (isNotUndefined(props.isEmptyExecuteCallback) && isNotEmpty(callbackFunc)) {
                    callbackFunc(callbackParam);
                }
                return;
            }

            // 自分の項目のblurから飛んできたかどうかの判定
            const hasblur = eventObj.hasBlur();
            // フォーカスアウト時変更がない場合、DB検索しない
            if (hasblur && value === element.data("before-input")) {
                // 「is-sameinput-execute-callback」属性があるとき、入力値に変更がないときでもコールバックを実行する
                if (isNotUndefined(props.isSameinputExecuteCallback) && isNotEmpty(callbackFunc)) {
                    callbackFunc(callbackParam);
                }
                return;
            }

            // formの定義がない場合、処理しない
            if (isEmpty(searchFormMap[props['searchform']]['form'])) return;

            // 追加引数の設定
            const addArgs = {
                "callbackFunc": callbackFunc,
                "callbackParam": callbackParam,
                "internalVar": internalVar,
                "authService": authService,
                "errCallbackFunc": errCallbackFunc,
                "errCallbackParam": errCallbackParam,
            };
            const asyncService = null;
            const GyCtrl = null;
            // 内部保持データ初期化
            setGyData(stateStore, props, "");
            execFinlyFuncFlg = false;

            // 入力コードでDB検索
            searchFormMap[props['searchform']]['form'](stateStore, props, asyncService, GyCtrl, value, errMsgService, addArgs);

            // 入力データ保持
            if (hasblur) element.data("before-input", value);
        } finally {
            // 画面側で生成した$q.defer()を閉じるための目的で追加したため、searchform実処理が動作するときは呼ばない仕様にしている。
            // 実処理中で非同期処理が走るので、画面側で閉じる処理をするとタイミングがずれて想定外の動きになる可能性があるため。
            if (isNotEmpty(finlyCallbackFunc) && execFinlyFuncFlg) {
                finlyCallbackFunc(finlyCallbackParam);
            }
        }
    }

    const keydownHandler = (event) => {
        if (props.onKeydown) {
            props.onKeydown(event);
        }
        if (!props.searchform) return;
        if (event.key === "F3") {
            element.blur();
            event.preventDefault();
        }
        shokaiShowup(event);
    }

    /**
     * モーダルの結果取得
     * 
     * @param {any} result 
     */
    const modalInstanceResult = (result) => {
        // 初期化
        element.data("before-input", "");
        // 支払先銀行コードの場合、複数のsearchformがあるため別処理で設定する
        let displayValue = result.code;
        if (isNotUndefined(props.setcollum)) {
            displayValue = getValueByKey(props.setcollum, result.row);
        }
        setValueByKey(props.name, stateStore.state, displayValue);
        // 取得したデータを保持
        // setValueByKey("gyData." + props.name, stateStore.state, result.row);
        // searchnameの値がnemeの値と一致する要素のng-modelを取得
        const searchNameNgModel = getSearchName(props.name);
        if (isNotEmpty(searchNameNgModel)) {
            setValueByKey(searchNameNgModel, stateStore.state, result.name);
        }
        // 検索ボタンで照会画面を起動した場合、テキストボックスにフォーカスをあてる
        closedProc();
    }

    /**
     * 画面を閉じた後の処理
     * 
     */
    const closedProc = () => {

        setIsModalHiden(true);
        setTimeout(() => {
            if (!document.querySelectorAll('.modal-dialog').length) {
                document.body.classList.remove('modal-open');
                document.body.querySelector('#root').classList.remove('modal-open');
            }
            textInput.current.focus();
            textInput.current.select();
        }, 10);
    }

    useImperativeHandle(ref, () => ({
        searchformExec: exec.bind(this),
        element: textInput.current
    }));

    /**
    * props.valueが未入力である場合、defvalueを設定するメソッド
    * @param {*} pValue 親コンポーネントのvalue
    * @returns defvalueまたは元のvalue
    */
    const doDefValue = (pValue) => {
        // フォーカスアウト状態で、defvalueが指定されていて、引数valueが空の場合、defvalueを返す
        if (!isFocus && !!props.defvalue && isEmpty(pValue)) {
            return props.defvalue;
        }
        // それ以外の場合、受け取った引数valueをそのまま返す
        return pValue;
    }

    /**
    * isdmaxlengthより引数valueの桁数が小さければ、padcharで文字詰めを行うメソッド
    * @param {*} pValue 親コンポーネントのvalue
    * @returns 文字詰め処理後のvalue
    */
    const doPadChar = (pValue, padchar, isdmaxlength) => {
        // 文字詰め対象文字列の文字数を算出
        const length = calcInputSize(pValue);
        // padcharの文字数を算出(全角1文字で文字詰めする場合、2文字分扱いとする)
        const padcharLength = calcInputSize(padchar);
        if (!isEmpty(pValue) && isdmaxlength > length) {
            // 文字詰めを行う
            let max = Math.floor((isdmaxlength - length) / padcharLength);
            for (let i = 0; i < max; i++) {
                pValue = padchar + pValue;
            }
        }
        return pValue;
    }

    // 
    /**
    * イベントのvalueに正規表現チェック、不適切な文字削除を行った後、
    * 親コンポーネントのvalue更新を行うメソッド
    * @param {*} e イベントオブジェクト
    */
    const doCheck = (e) => {
        let eValue = e.target.value;
        // ctrlproptypeを必要とするチェック処理
        if (!!props.ctrlproptype) {
            // ctrlproptypeの読み込み
            if (!isEmpty(props.ctrlproptype) && typeof props.ctrlproptype === 'string') {
                valueOfCtrlPropType = props.ctrlproptype;
            } else {
                valueOfCtrlPropType = "alphanum";
            }
            // IME入力がfalseの場合、入力内容のチェック処理を行う
            if (!isIme) {
                // 正規表現チェック
                const regexp = new RegExp(setPattern(valueOfCtrlPropType), "g");
                if (!e.target.value.toString().match(regexp)) {
                    eValue = (!!props.isNotReplaceNoMatchRegexp && !!isPaste) ? '' : replaceByPattern(valueOfCtrlPropType, e.target.value);
                }
                // maxintlength、maxdeclengthのチェック
                if (valueOfCtrlPropType.indexOf("num") == 0) {
                    const maxIntLength = !!props.maxintlength ? props.maxintlength : null;
                    const maxDecLength = !!props.maxdeclength ? props.maxdeclength : null;
                    eValue = doMaxIntDecLength(eValue, maxIntLength, maxDecLength);
                }
            }
            isPaste = false;
            if (!!props.format) {
                // 「/」を含むとき、一度数値のみにして後続で整形する
                const inputval = eValue.replace(/[\/]/g, "");
                const yyyy = inputval.substr(0, 4); // 年
                const mm = inputval.substr(4, 2);   // 月
                const dd = inputval.substr(6, 2);   // 日

                switch (inputval.length) {
                    case 5: // YYYYM  → YYYY/M
                    case 6: // YYYYMM → YYYY/MM
                        eValue = `${yyyy}/${mm}`;
                        break;
                    case 7: // YYYYMMD → YYYY/MM/D
                    case 8: // YYYYMMDD → YYYY/MM/DD
                        eValue = `${yyyy}/${mm}/${dd}`;
                        if (props.format === constMap.format.yyyymm) {
                            eValue = `${yyyy}/${mm}`;
                        }
                        break;
                    default:
                        if (8 < inputval.length) eValue = `${yyyy}/${mm}/${dd}`;
                }
            }

        }
        // ctrlproptypeを必要としないチェック処理
        if (!isIme) {
            // isdmaxlengthのチェック
            if (!!props.isdmaxlength) {
                eValue = delInputOverSize(eValue, props.isdmaxlength);
            }
        }
        // 当メソッドの処理でvalueに変更があった場合、変更後のvalueで親コンポーネントのvalueを更新する
        if (eValue != e.target.value) {
            setTimeout(() => {
                setValue(eValue);
                if (!props.dataGrid) {
                    stateStore.setState(props.name, eValue)
                } else {
                    if (!!props.onChange) {
                        props.onChange(e);
                    }
                };
            }, 0)
        }
        // 当メソッドの処理でvalueに変更がない場合、親コンポーネントのonChangeイベントからvalueを更新する
        else {
            setValue(e.target.value);
            if (!props.dataGrid) stateStore.setState(props.name, eValue);
            if (!!props.onChange) {
                props.onChange(e);
            }
        }
    }


    /**
     * 入力制限を超過した文字を削除するメソッド
     * @param {*} eValue イベントオブジェクトのバリュー
     * @param {*} isdmaxlength 入力制限文字数
     * @returns 
     */
    const delInputOverSize = (eValue, isdmaxlength) => {
        // 文字数を算出
        const eLength = calcInputSize(eValue);

        // 超過した文字の削除
        if (eLength > isdmaxlength) {
            let deleteLength = eLength - isdmaxlength;
            eValue = eValue.slice(0, -deleteLength);
        }
        return eValue;
    }

    /**
    * 入力値の整数部の桁数がmaxintlengthより大きい場合、余剰した整数部を削除し、
    * 入力値の小数部の桁数がmaxdeclengthより大きい場合、余剰した小数部を削除するメソッド
    * @param {*} eValue イベントオブジェクトのvalue
    * @returns 余剰した桁数を削除したあとのvalue
    */
    const doMaxIntDecLength = (eValue, maxIntLength, maxDecLength) => {
        // もしeValueが空、またはmaxintlength、maxdeclengthどちらの指定もなかった場合、引数valueをそのまま返し、処理を終了する
        if (isEmpty(eValue) || (isEmpty(maxIntLength) && isEmpty(maxDecLength))) {
            return eValue;
        }
        // 引数valueを整数部、小数部に分割する
        const checkValue = (String(eValue)).split('.');
        // maxintlengthより整数部の桁数が大きい場合、余剰した整数部を削除する
        if (!!maxIntLength) {
            let deleteIntLength = checkValue[0].length - maxIntLength;
            if (deleteIntLength > 0) {
                checkValue[0] = checkValue[0].slice(0, -deleteIntLength);
            }
        }
        // maxdeclengthより小数部の桁数が大きい場合、余剰した小数部を削除する
        if (!!maxDecLength && !isEmpty(checkValue[1])) {
            let deleteDecLength = checkValue[1].length - maxDecLength;
            if (deleteDecLength > 0) {
                checkValue[1] = checkValue[1].slice(0, -deleteDecLength);
            }
        }
        // 分割した引数valueの整数部、小数部を再び結合し、その値を返す
        return checkValue.join('.');
    }

    /**
    * displayTypeに"comma"がある場合、3桁カンマ区切りでフォーマットするメソッド
    * @param {*} dType displayType
    * @param {*} pValue 親コンポーネントのvalue
    * @returns フォーマット後の親コンポーネントvalue
    */
    const format = (dType, pValue) => {
        // valueがnullの場合、空文字を画面に表示する
        if (pValue === null) {
            return "";
        }
        // フォーカス時はそのままのvalueを画面に表示する
        if (dType == "focus") {
            return pValue;
        }
        // displayTypeを参照し、valueの表示形式を変更する
        let dispValue = pValue;
        const dTypeArray = dType.split(".");
        const isNum = dTypeArray.includes("num");
        const isComma = dTypeArray.includes("comma");
        if (isNum && !isEmpty(dispValue)) {
            dispValue = Number(dispValue).toLocaleString(undefined, {
                useGrouping: isComma
            })
        }
        return dispValue;
    };


    // フォーカスインした時のイベント
    const onFocus = (event) => {
        // フォーカスフラグをtrueに更新
        isFocus = true;
        // displayTypeを"focus"に更新
        setDisplayType("focus");
        // テキストボックス内の値を全選択状態にする
        event.target.select();
        // 名称データ保持
        if (isNotEmpty(getSearchName(props.name))) {
            stateStore.state.beforedataname = getValueByKey(getSearchName(props.name), stateStore.state);
        }
        if (!!props.onFocus) {
            props.onFocus(event);
        }
    }



    // IME入力処理が発生した時のイベント
    const onCompositionStart = () => {
        // IME入力フラグをtrueに更新
        isIme = true;
    }

    // IME入力処理が終了した時のイベント
    const onCompositionEnd = (event) => {
        // IME入力フラグをfalseに変更
        isIme = false;
        // 現在の入力値をチェックし、親コンポーネントのvalueに反映させる
        doCheck(event);
    };

    // 入力値が変更された時のイベント
    const onChange = (event) => {
        // 現在の入力値をチェックし、親コンポーネントのvalueに反映させる
        doCheck(event);
        if (isNotUndefined(props.searchform)) {
            // 前回入力値を初期化する
            element.data("before-input", "");

            // 値変更時、名称表示部を初期化する
            // 名称表示部のng-model名が存在しない場合処理をスキップする
            if (isEmpty(getSearchName(props.name))) return;

            // 値がある場合空文字で初期化する
            if (!!getValueByKey(getSearchName(props.name), stateStore.state)) {
                setValueByKey(getSearchName(props.name), stateStore.state, "");
            }
        }
    };

    // フォーカスアウトした時のイベント
    const onBlur = (event) => {
        if (props.dataGrid && event['_reactName'] && event['_reactName'] == 'onBlur') return;
        let errorCounter = 0;
        // フォーカスフラグをfalseに更新
        isFocus = false;
        // valueを取得する
        let eValue = event.target.value;
        // ctrlproptypeが指定されている場合、displayTypeをctrlproptypeの値で更新
        if (!isEmpty(props.ctrlproptype) && typeof props.ctrlproptype === 'string') {
            setDisplayType(props.ctrlproptype);
        } else {
            setDisplayType("");
        }
        // 未入力チェック
        if (!!props.required && !props.defvalue && isEmpty(event.target.value.trim())) {
            // 未入力エラーメッセージを登録
            errorCounter++;
            errMsgService.addMsgLabel(baseCheckErrCd.require, props);
        } else {
            // 未入力エラーメッセージを解除
            errMsgService.delMsgLabel(props);
        }
        // checkFormatのチェック
        if (!!props.checkFormat && !isEmpty(props.checkFormat)) {
            let isFormatError = false;
            switch (props.checkFormat) {
                case "mail":
                    if (!stateStore.state[props.name].match(/^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/g)) {
                        isFormatError = true;
                    }
                    break;
                default:
            }
            if (isFormatError) {
                // checkFormatエラーメッセージを登録
                errorCounter++;
                errMsgService.addMsgLabel(baseCheckErrCd.email, props);
            } else {
                // 未入力エラーメッセージを解除
                errMsgService.delMsgLabel(props);
            }
        }
        // defvalueが指定されていてvalueが未入力である場合、defvalueを設定する
        eValue = doDefValue(eValue);
        // padcharが指定されている場合、文字詰め処理を行う
        if (!!props.padchar && !!props.isdmaxlength) {
            eValue = doPadChar(eValue, props.padchar, props.isdmaxlength);
        }
        // 当イベント処理でvalueに変更があった場合、変更後のvalueで親コンポーネントのvalueを更新する
        if (eValue != event.target.value) {
            setValue(eValue);
            stateStore.setState(props.name, eValue);
        }
        // 親コンポーネントにフォーカスアウト時のイベントが指定されている場合、実行する
        if (!!props.onBlur) {
            props.onBlur(event);
        }
        // エラーの有無でisErrorの状態を更新する
        if (errorCounter > 0) {
            setIsError(true);
        } else if (isError) {
            setIsError(false);
        }

        if (isNotUndefined(props.searchform)) {
            eventObj.setBlur(true);
            // フォーカスアウトを止めるプロパティの設定やボタンから呼び出された場合は処理しない
            if (isNotUndefined(props.stopBlurSearch) || event.currentTarget.localName === "button") return;

            // 処理実行（nullの引数は内部関数のコールバック関数用のため、設定不要）
            exec(null, null, null, null, null, event);

            // 名称データ保持
            if (isNotEmpty(getSearchName(props.name))) {
                stateStore.state.beforedataname = getValueByKey(getSearchName(props.name), stateStore.state);
            }
        }
    }

    //blurイベント判別する用
    const eventObj = {
        setBlur: function (flg) {
            isBlur = flg;
        },
        hasBlur: function () {
            // 初期化を一緒に行うため一度別変数に保持する
            const value = isBlur;
            // 初期化する
            isBlur = false;
            return value;
        }
    }

    // classNameの生成
    // className属性を格納する配列を宣言
    let classNameArray = [];
    // propsにclassNameがあれば、className配列に追加
    if (!!props.className && !isEmpty(props.className)) {
        let pcnArray = props.className.split(" ");
        classNameArray = [...classNameArray, ...pcnArray];
    }
    // propsにrequiredがあれば、classNameに"require"追加
    if (!!props.required) {
        classNameArray.push("require");
    }
    // propsにnumがあれば、classNameに"align-right"追加
    if (!!props.ctrlproptype && typeof props.ctrlproptype === 'string' && props.ctrlproptype.includes("num") && !classNameArray.includes("align-right")) {
        classNameArray.push("align-right");
    }
    // エラーが1個以上で、propsにdisabledが指定されておらず、まだclassNameに"error-place"がなければ、classNameに"error-place"を追加
    if (!props.disabled && isError && !classNameArray.includes("error-place")) {
        classNameArray.push("error-place");
    }
    // 配列classNameArrayの要素からclassNameを生成する
    let className = classNameArray.join(" ");

    return (
        <>
            {!props.searchform ? <input autoComplete="off"
                disabled={props.disabled ? 'disabled' : ''}
                type={!!props.type ? props.type : 'text'}
                className={'form-control ' + className}
                searchname={props.searchname}
                onKeyDown={keydownHandler}
                id={props.id}
                name={props.name}
                value={format(displayType, value)}
                ref={textInput}
                placeholder={props.placeholder}
                onCompositionStart={onCompositionStart} onCompositionEnd={onCompositionEnd}
                onChange={onChange} onBlur={onBlur} onFocus={onFocus} onPaste={() => { isPaste = true; }}
            /> :
                <div className='search-form-container'>
                    <input autoComplete="off"
                        disabled={props.disabled ? 'disabled' : ''}
                        type={!!props.type ? props.type : 'text'}
                        replaced={inputConfig.replaced}
                        onKeyDown={keydownHandler}
                        size={inputConfig.size}
                        maxLength={inputConfig.isdMaxlength}
                        ref={textInput}
                        className={'form-control input-search-form ' + className}
                        id={props.id}
                        name={props.name}
                        value={format(displayType, value)}
                        onCompositionStart={onCompositionStart} onCompositionEnd={onCompositionEnd}
                        onChange={onChange} onBlur={onBlur} onFocus={onFocus} />
                    {
                        isUndefined(props.isPrimaryKey) &&
                        <span className="input-group-btn" disabled={props.disabled ? 'disabled' : ''}>
                            <button id="searchformBtn" onClick={shokaiShowup} tabIndex="-1"
                                onMouseEnter={() => { isErrMsgDisp = true; }} onMouseLeave={() => { isErrMsgDisp = false; }} className="btn btn-default btn-popup">
                                <i className="glyphicon glyphicon-option-vertical"></i>
                            </button>
                            {
                                multilModel && <button id="multiModalBtn" tabIndex="-1" onClick={shokaiShowup} className="btn btn-default btn-popup"
                                    onMouseEnter={() => { isErrMsgDisp = true; }} onMouseLeave={() => { isErrMsgDisp = false; }} replaced="true" focusmove="true" multi-modal-btn="true">
                                    <i className="glyphicon glyphicon-plus" multi="true"></i>
                                </button>
                            }
                        </span>
                    }
                </div>
            }
        </>
    );
}))

export default IsdTextBox;


// 以下、定数や当コンポーネント内で使用するメソッド
// 入力文字タイプ
const proptypes = {
    NUM: "num"
    , TEL: "tel"
    , DATE: "date"
    , ALPHANUM: "alphanum"
    , ALPHANUMSIGN: "alphanumsign"
    , KANA: "kana"
    , JAPAN: "japan"                // この2項目は正規表現をかけないが、
    , ALL: "all"                    // 互換性を損ねないようにproptypesとして残しておきます
    , DOT: "dot"
    , COMMA: "comma"
    , MINUS: "minus"
    , PLUS: "plus"
    , SPACE: "space"
};

// 入力文字タイプに応じた入力可能文字
const patterns = {
    NUM: "^[0-9]*$"                    // 半角数字
    , TEL: "^[0-9]*$"                // 半角数字のみに変更
    , DATE: "^[0-9\\/]*$"               // 日付　追記：この項目はisdTextBoxで扱わないが、とりあえず
    , ALPHANUM: "^[0-9a-zA-Z ]*$"       // 半角英数字
    , ALPHANUMSIGN: "^[\x01-\x7E]*$"    // 半角英数字記号(1byte文字のみ)
    , KANA: "^[\x01-\x7E|ｧ-ﾝｦﾞﾟ･]*$"    // 半角ｶﾅ
    , JAPAN: "^[^ｧ-ﾝｦﾞﾟ]*$"             // 全角文字(半角ｶﾅ以外) 
};

// replaceメソッドに使用する文字
const replacePatterns = {
    NUM: "[^0-9]"                      // 半角数字(replace)
    , TEL: "[^0-9]"                  // 半角数字のみに変更
    , DATE: "[^0-9\\/]*$"               // 日付(replace)　追記：この項目はisdTextBoxで扱わないが、とりあえず
    , ALPHANUM: "[^0-9a-zA-Z ]"       // 半角英数字(replace)
    , ALPHANUMSIGN: "[^\x01-\x7E]"    // 半角英数字記号(1byte文字のみ)(replace)
    , KANA: "[^\x01-\x7E|ｧ-ﾝｦﾞﾟ･]"    // 半角ｶﾅ(replace)
    , JAPAN: "[^ｧ-ﾝｦﾞﾟ]"             // 全角文字(半角ｶﾅ以外)(replace) 
};

const baseCheckErrCd = {
    require: "ESYS0090",
    inputOkNg: "WCMN0150",
    inputSize: "EWEB0100",
    onlyPadchar: "ESYS0400",
    dateFormat: "ESYS0100",
    dayFormat: "ESYS0060",
    fromTo: "ESYS0080",
    email: "ESYS0410"
};

/**
* 正規表現のチェックパターンを作成するメソッド
* @param {*} ptn ctrlproptype
* @returns 正規表現のチェックパターン
*/
export const setPattern = (ptn) => {
    // 正規表現項目を格納する変数
    let madePattern = "";
    // ptnArray[0]から、正規表現をチェックする
    switch (ptn) {
        case proptypes.NUM:
            madePattern = patterns.NUM; break;
        case proptypes.TEL:
            madePattern = patterns.TEL; break;
        case proptypes.DATE:
            madePattern = patterns.DATE; break;
        case proptypes.ALPHANUM:
            madePattern = patterns.ALPHANUM; break;
        case proptypes.ALPHANUMSIGN:
            madePattern = patterns.ALPHANUMSIGN; break;
        case proptypes.KANA:
            madePattern = patterns.KANA; break;
        case proptypes.ALL:
        case proptypes.JAPAN:
            // japanとallについては正規表現のチェックはかけない
            break;
        default:
            // どのケースにも引っかからない場合の処理
            // 第二引数ptnをドット区切りにしてチェックパターンを生成する
            const ptnArray = ptn.split('.');
            for (let i = 0; i < ptnArray.length; i++) {
                switch (ptnArray[i]) {
                    case proptypes.NUM:
                        madePattern += "0-9"; break;
                    //case proptypes.COMMA:
                    //    madePattern += "\\,"; break;                        // コンマは入力させず、formatメソッドを使って表示させる
                    case proptypes.MINUS:
                        madePattern += "\\-"; break;
                    case proptypes.DOT:
                        madePattern += "\\."; break;
                    //case proptypes.SPACE:
                    //    madePattern += " "; break;
                    default:
                }
            }
            // 生成したsetedPatternの形を直す
            madePattern = ("^[" + madePattern + "]*$");
    }
    return madePattern;
}

/**
* 正規表現チェックに応じて文字列の削除を行うメソッド
* @param {*} ptn ctrlproptype
* @param {*} value チェック対象の文字列
* @returns 
*/
export const replaceByPattern = (ptn, value) => {
    // valueを変数に格納する
    let resultValue = value;
    // 正規表現項目を格納する変数
    let madePattern = "";
    // 正規表現をチェックし、replaceのパターンを生成する
    switch (ptn) {
        case proptypes.NUM:
            madePattern = replacePatterns.NUM; break;
        case proptypes.TEL:
            madePattern = replacePatterns.TEL; break;
        case proptypes.DATE:
            madePattern = replacePatterns.DATE; break;
        case proptypes.ALPHANUM:
            madePattern = replacePatterns.ALPHANUM; break;
        case proptypes.ALPHANUMSIGN:
            madePattern = replacePatterns.ALPHANUMSIGN; break;
        case proptypes.KANA:
            madePattern = replacePatterns.KANA; break;
        case proptypes.ALL:
        case proptypes.JAPAN:
            // japanとallについては正規表現のチェックはかけない
            break;
        default:
            // どのケースにも引っかからない場合の処理
            // 第二引数ptnをドット区切りにしてチェックパターンを生成する
            const ptnArray = ptn.split('.');
            for (let i = 0; i < ptnArray.length; i++) {
                switch (ptnArray[i]) {
                    case proptypes.NUM:
                        madePattern += "0-9"; break;
                    //case proptypes.COMMA:
                    //    madePattern += "\\,"; break;         // コンマは入力させず、formatメソッドを使って表示させる
                    case proptypes.MINUS:
                        madePattern += "\\-"; break;
                    case proptypes.DOT:
                        madePattern += "\\."; break;
                    //case proptypes.SPACE:
                    //    madePattern += " "; break;
                    default:
                }
            }
            // 生成したsetedPatternの形を直す
            madePattern = ("[^" + madePattern + "]");
    }
    resultValue = isNotUndefined(resultValue) ? String(resultValue).replace(new RegExp(madePattern, 'g'), () => '') : '';
    // replaceしたvalueを返す
    return resultValue;
}
